import * as reduxSagaService from './../../../common/services/redux-saga';

import {watchSessionProfileIsUpdated} from './common/onSessionProfileUpdate';

export default reduxSagaService.createRootSaga(
  watchSessionProfileIsUpdated
);